export default __webpack_public_path__ + "static/23-85276b7b789ffbc09eeac315c9efb3f8.jpg";